export enum CognitoErrors {
  EXPIRED_CODE = 'ExpiredCodeException',
  CODE_MISMATCH = 'CodeMismatchException',
  LIMIT_EXCEEDED = 'LimitExceededException',
  CODE_DELIVERY_FAILURE = 'CodeDeliveryFailureException',
  USERNAME_EXISTS = 'UsernameExistsException',
  NOT_AUTHORIZED = 'NotAuthorizedException',
}
